import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Checkbox from "../../components/inputs/checkbox";
import { useDispatch } from "react-redux";
import { create } from "../../services/services";
import {
  Elements,
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PayWithCards from "./payWithCards";
function PaiementForm({plan,from,free}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const [clientSecret, setClientSecret] = useState(null);
  const [error, setError] = useState(null);
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLIC_KEY
  );
 
  const htAmount = parseFloat(plan?.discounted_price_eur);
  const vatRate = 0.20; // Adjust this based on your country's VAT rate
  const vatAmount = htAmount * vatRate;
  const ttcAmount = htAmount + vatAmount;
  const [savePaimentMethod, setSavePaimentMethod] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const options = {
    clientSecret,
  };
  const fetchSecret = async () => {
    if(from==='account' && !free){
      create({new_plan_id:plan?.id,return_url:'/compte/prestataire/mon-plan'},'initiate-upgrade')
      .then((res)=>{
        //  console.log(res)
         window.location.href=res?.data?.payment_url
        // setClientSecret(res?.data?.client_secret);

      })
      .catch((err)=>{
        // console.log(err)
      })
    }else{
      const data = { plan_id: plan.id,return_url:from==='account' ?'/compte/prestataire/mon-plan':'/confirmation' };
    create(data, "subscription/plan")
      .then((res) => {
        setClientSecret(res?.data?.client_secret);
        //setLoading(false);
      })
      .catch((err) => {
        // console.error(err);
        setError("Failed to load payment form. Please try again.");
       
      }); 
    }
   
  };
 
 
  useEffect(() => {
    fetchSecret();
  }, []);
  return (
    <>
     
        <div className="container">
          <div className=" mt-48">
            <h3 className="grey500">Paiement</h3>
            <div className="row">
            <div className="col-md-8">
          <div className="payment-form-container">
            {clientSecret ? (
              <>
              <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
                <EmbeddedCheckout className="StripeEmbeddedCheckout" />
              </EmbeddedCheckoutProvider>
           
              {/* <Elements stripe={stripePromise} options={{ clientSecret }}>
                <PayWithCards />
              </Elements> */}
   
            </>
            ) : (
              <div className="loading-state">
                {error ? <p className="error">{error}</p> : <p>Loading payment form...</p>}
              </div>
            )}
          </div>
        </div>
              <div className="col-md-4">
                <div className="recap">
                  <h4 className="bg500">Récapitulatif</h4>
                  <div className="d-flex justify-content-between mt-16">
                    <p className="body bold500 bg500">
                      Business Pro - Plan {plan?.duration_in_months} mois
                    </p>
                    <p className="body bold500 bg500">{parseFloat(plan?.default_price_eur)} €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66">Traitement de cartes 0%</p>
                    <p className="body grey66">0 €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66">Commission 0%</p>
                    <p className="body grey66">0 €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66">
                      Prise de rendez-vous illimitées
                    </p>
                    <p className="body grey66">0 €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66">Emplacements illimités</p>
                    <p className="body grey66">0 €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66">
                      Clients illimités et notification par e-mail
                    </p>
                    <p className="body grey66">0 €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66">Rapports illimités</p>
                    <p className="body grey66">0 €</p>
                  </div>
                  <div className="d-flex justify-content-between mt-24">
                    <p className="body bold500 green">
                      Remise sur le plan 
                    </p>
                    <p className="body bold500 green">- {parseFloat(plan?.default_price_eur) - parseFloat(plan?.discounted_price_eur)} €</p>
                  </div>
                  <hr />
                  <div className="d-flex justify-content-between ">
                    <p className="body grey500">
                      Total <span className="bold500">HT</span>{" "}
                    </p>
                    <p className="body grey500">{plan?.discounted_price_eur} €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66 ">TVA</p>
                    <p className="body grey66">{vatAmount.toFixed(2)} €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <h5 className="body grey500">
                      {" "}
                      <span className="bold500">Total </span>TTC{" "}
                    </h5>
                    <h5 className="body grey500">{ttcAmount.toFixed(2)} €</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ht-100"></div>
     
    </>
  );
}

export default PaiementForm;
